/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const changeTrialPlanDataIntervalSchema = z.enum(['monthly', 'yearly'])

export type ChangeTrialPlanDataIntervalSchema = z.infer<typeof changeTrialPlanDataIntervalSchema>
